import { defineNuxtPlugin, useRuntimeConfig } from "#imports";
export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const config = useRuntimeConfig();
    let matomoHost = config.public.matomo.host;
    const matomoContainerId = config.public.matomo.containerId;
    if (matomoHost.includes("matomo.cloud")) {
      const domain = new URL(matomoHost).hostname;
      matomoHost = `https://cdn.matomo.cloud/${domain}`;
    }
    if (matomoHost && matomoContainerId) {
      const url = `${matomoHost}/js/container_${matomoContainerId}.js`;
      const _mtm = window._mtm = window._mtm || [];
      _mtm.push({ "mtm.startTime": (/* @__PURE__ */ new Date()).getTime(), "event": "mtm.Start" });
      (function() {
        const d = document, g = d.createElement("script"), s = d.getElementsByTagName("script")[0];
        g.async = true;
        g.src = url;
        s.parentNode.insertBefore(g, s);
      })();
    }
  }
});
